module.exports = "<div class=search-import-con> <table class=search-import-table> <tr> <td>文件上传(.ini)</td> <td> <div class=search-upload-box></div> <button class=search-uploader-button type=button>选择文件</button> <span class=file-name>未选择任何文件</span> </td> </tr> <tr> <td>是否覆盖相同的已有常用查询</td> <td> <span class=choice-input> <input class=\"yes active\" type=checkbox> <lable>是</lable> </span> <span class=choice-input> <input class=no type=checkbox> <lable>否</lable> </span> </td> </tr> </table> <span class=search-import-submit-btn>导入</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/dataGrid/data-table-toolbar/expert-search-import/search-import.html
// module id = 2071
// module chunks = 50